import React, { createContext, useState, useContext } from "react";

const SecaoEnunciadoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [secaoEnunciado, setSecaoEnunciado] = useState();

  return (
    <SecaoEnunciadoContext.Provider value={{ secaoEnunciado, setSecaoEnunciado }} >
      {children}
    </SecaoEnunciadoContext.Provider>
  );
}

export function useSecaoEnunciadoContext() {
  const context = useContext(SecaoEnunciadoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { secaoEnunciado, setSecaoEnunciado } = context;
  return { secaoEnunciado, setSecaoEnunciado };
}

